import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddAccount } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddAccountPage: FC = () => {
  const { accessToAddFacebookadaccount } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToAddFacebookadaccount}>
      <CabinetTitlePage
        title={'Accounts'}
        goBack={'/cabinet/facebook/accounts'}
      />
      <AddAccount />
    </Guard>
  );
};

export default AddAccountPage;
